import moment from 'moment';

import { applicationStatuses } from "../config/constants";
const debug = process.env.REACT_APP_DEBUG === 'true';

// Pre-save processing methods. No longer do anything
// Remove empty strings from objects because they break Dynamo

// Apparently fixed by adding convertEmptyValue: true to DocumentClient
// Leaving in just in case pre-save processing is needed
export function sanitizeEducationInfo(educationInfo) {
    return educationInfo;
}

export function sanitizeOtherInfo(otherInfo) {
    return otherInfo;
}

export function sanitizeBasicInfo(basicInfo) {
    return basicInfo;
}

export function sanitizeProfessionalInfo(professionalInfo) {
    return professionalInfo;
}

export function sanitizePTRequirementsInfo(ptRequirementsInfo) {
    return ptRequirementsInfo;
}

// If we haven't passed the notification date, don't show the current status
export function getStatusForApplication (application, period) {
    // If we don't send a period, we can't calculate so just find the status
    if(!period) {
        console.log('Period not found. Showing status.');
        return findStatus(application.status);
    }
    // If it's after the notification date, don't hide the final status
    const ranking = moment(period.rankingDate).add(8, 'hours');
    const applicationStatus = findStatus(application.status);
    if(moment().isAfter(ranking)) {
        return applicationStatus;
    }
    // If status is above Invited, return Invited
    if (applicationStatus.level > applicationStatuses.INVITED.level)
        return applicationStatuses.INVITED;
    return applicationStatus;
}

const findStatus = (status) => Object.values(applicationStatuses).find(aStatus => aStatus.code === status);

export const debugLog = (...message) => debug ? console.log('DEBUG', ...message) : '';